import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme';

import { GlobalStyle } from 'index.styles';
import { GoLandingPage } from 'containers/GoLandingPage/GoLandingPage';

const hostname = window.location.hostname;
const pathname = window.location.pathname;
const isPreviewHost =
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname === '::1' ||
  hostname.endsWith('.amplifyapp.com');
// TEMPORARY: remove the /go preview after design sign-off.
const isGoPreview =
  isPreviewHost && (pathname === '/go' || pathname.startsWith('/go/'));
const isGoLandingExperience =
  window.__FAROUT_GO_LANDING__ ??
  (hostname === 'go.faroutguides.com' || isGoPreview);

const render = (app: React.ReactNode) => {
  ReactDOM.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        {app}
      </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );
};

const renderLoadError = () => {
  render(
    <main role="alert" style={{ padding: 32, textAlign: 'center' }}>
      <h1>FarOut couldn’t load.</h1>
      <p>Please refresh the page to try again.</p>
    </main>
  );
};

if (isGoLandingExperience) {
  render(<GoLandingPage />);
} else {
  // Keep main-app services out of the go landing bundle and wait for the
  // external dependencies that were historically loaded before React. The
  // fallback also protects users during a cached HTML/JavaScript mismatch.
  const mainDependenciesReady =
    window.__FAROUT_MAIN_DEPENDENCIES_READY__ ?? Promise.resolve();

  mainDependenciesReady
    .then(() => import('./MainWebApp'))
    .then(({ MainWebApp }) => render(<MainWebApp />))
    .catch(error => {
      console.error('Unable to load the FarOut web app.', error);
      renderLoadError();
    });
}
